import styled from 'styled-components';

import { scale080, spaceS } from '@xingternal/tokens';

export const StyledInfoIcon = styled.li`
  display: flex;
  font-size: ${scale080};

  & svg {
    margin-right: ${spaceS};
  }
`;
